import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material/bottom-sheet";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AddNewCardComponent } from "../add-new-card/add-new-card.component";
import { PaymentService } from "src/app/services/payment.service";
import { PAYMENT_FAIL, PAYMENT_SUCCESS } from "src/app/app.constants";
import { SyndicateTicketsComponent } from "src/app/pages/syndicate/syndicate-tickets/syndicate-tickets.component";
import { CustomAnimation } from "src/app/directives/modal-transistion";
import { ModalController, IonicModule } from "@ionic/angular";
import { Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { InProgressAnimationComponent } from "../../in-progress-animation/in-progress-animation.component";
import { AsyncPipe } from "@angular/common";
@Component({
    selector: "app-existing-card",
    templateUrl: "./existing-card.component.html",
    styleUrls: ["./existing-card.component.scss"],
    standalone: true,
    imports: [
        IonicModule,
        InProgressAnimationComponent,
        AsyncPipe,
        TranslatePipe,
    ],
})
export class ExistingCardComponent implements OnInit {

  @ViewChild("cardSlide", { static: false }) cardSlides;

  userAndCardDetails$ = this.paymentService.userPaymentDetails$;

  constructor(
    private bottomSheet: MatBottomSheet,
    private bottomSheetRef: MatBottomSheetRef<ExistingCardComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private paymentService: PaymentService,
    private snackbar: MatSnackBar,
    private modalCtrl: ModalController,
    private router: Router,
    private authService: AuthService,
    public translate: TranslateService
  ) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        if (l) {
          translate.use(l ? l : "en");
        }
      },
      (err) => {
        return err;
      }
    );
  }

  ngOnInit() {}

  openAddNewCard() {
    const addNewCard = this.bottomSheet.open(AddNewCardComponent, {
      panelClass: "add-payment-method-dialog",
    });
  }

  makePayment(cardDetails, userDetails) {
    if (this.data.orderId) {
      cardDetails["PS_orderId"] = this.data.orderId;
    }
    this.cardSlides?.getActiveIndex().then((selectedCardIndex) => {
        const offerPurchase = {
          offer_id: cardDetails && cardDetails.offer_id ? cardDetails.offer_id : null,
          prosub_id: cardDetails && cardDetails?.prosub_id ? cardDetails?.prosub_id : null,
          total_cost: cardDetails && cardDetails.total_cost ? cardDetails.total_cost : null,
        };

        if (cardDetails && cardDetails.PS_orderId) {
          this.makePaymentSecurely(
            offerPurchase,
            userDetails,
            cardDetails.cards[selectedCardIndex],
            cardDetails.PS_orderId,
            cardDetails
          );
        } else {
          this.getPurchaseId(offerPurchase?.offer_id, offerPurchase.total_cost).then((purchaseId: any) => {
              this.makePaymentSecurely(
                offerPurchase,
                userDetails,
                cardDetails.cards[selectedCardIndex],
                purchaseId,
                cardDetails
              );
            })
            .catch((error) => {
              return error;
            });
        }
      })
      .catch((error) => {
        return error;
      });
  }

  private getPurchaseId(offerId, amountToPay): Promise<any> {
    return new Promise((resolve, reject) => {
      // this.paymentService.insertCustomerPurchase(offerId, amountToPay).subscribe((customerPurchase: any) => {
      //   if (customerPurchase) {
      //     const purchaseId = customerPurchase[0].insert_customer_purchase.response.customer_purchase_id;
      //     if (purchaseId) {
      //       resolve(purchaseId);
      //     } else {
      //       reject("something went wrong");
      //     }
      //   }
      // });
    });
  }

  private makePaymentSecurely(offerDetails, userDetails, card, purchaseId, cardDetails) {
    this.paymentService?.makePaymentWithPayMilGateway(offerDetails, userDetails, card, purchaseId)?.subscribe(
      (PayMilProcessedResponse: any) => {
        if (
          PayMilProcessedResponse &&
          PayMilProcessedResponse[0] &&
          PayMilProcessedResponse[0].process_paymill_card_payment &&
          PayMilProcessedResponse[0].process_paymill_card_payment?.response &&
          PayMilProcessedResponse[0].process_paymill_card_payment?.response?.status === "SUCCESS"
        ) {
          this.snackbar.open(PAYMENT_SUCCESS, "OK!", {
            duration: 3000,
            verticalPosition: "top",
          });
          this.afterPaymentDone(purchaseId, cardDetails);
        } else {
          this.snackbar.open(PAYMENT_FAIL, "OK!", {
            duration: 3000,
            verticalPosition: "top",
          });
        }
      },
      (err) => {
        return err;
      }
    );
  }

  afterPaymentDone(purchaseId, cardDetails) {
    // if (cardDetails.ps_id) {
    //   this.viewTicketPage({
    //     syndicate_id: cardDetails.ps_id.ps_id,
    //     syndicate_type: "Private",
    //   });
    // } else if (purchaseId) {
    //   this.privateSyndicateService.getTicketDetailsWithPurchaseId(purchaseId).subscribe((ticketDetails: any) => {
    //     const ticketPageData = ticketDetails.response[0].get_success_page_details.response;
    //     if (ticketPageData.status !== "FAIL") {
    //       this.viewTicketPage(ticketPageData);
    //     } else {
    //     }
    //   });
    // }
  }

  private async viewTicketPage(ticketPageData: any) {
    const syndicateTickets = await this.modalCtrl.create({
      component: SyndicateTicketsComponent,
      componentProps: { ticketPageData },
      cssClass: "modal-fullScreen",
      // enterAnimation: CustomAnimation.enterFromRight,
      //  leaveAnimation: CustomAnimation.exitThroughRight,
    });
  }

  goBack() {
    this.bottomSheetRef.dismiss();
  }

  /*async goToViewTicketpage() {
    this.bottomSheetRef.dismiss();
    this.router.navigateByUrl("/viewTicket");
  }*/
}
